import React, { useEffect } from "react";
import './Inicio.scss'
import logo from '../../assets/img/logo.png'

const Inicio = ()=>{
   
    return(
        <div className="Inicio">
            <div className="contenido">
                <div className="tituloApp">MONITOR</div>
            </div>
            
        </div>
    )
}
export default Inicio